export default __webpack_public_path__ + "static/media/pills.49f496ad.png";